import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './RehabManufacturerIndia.css';

const RehabManufacturerIndia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "logo": "https://www.primerehabindustries.in/logo.png",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "areaServed": "India",
          "priceRange": "Contact for pricing"
        },
        {
          "@type": "Product",
          "name": "Rehabilitation Equipment",
          "description": "Prime Rehab Industries manufactures rehabilitation equipment for clinics and hospitals across India, including traction tables, tilt tables, Bobath tables, treatment tables, unweighing systems, and chiropractic equipment.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "135",
            "bestRating": "5"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Preethi Shanmugam" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-02-18",
              "reviewBody": "Prime Rehab delivered on time and their after-sales follow-up has been reliable. The traction table we ordered is performing exactly as specified."
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Ramesh Babu" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-09-12",
              "reviewBody": "The installation was handled professionally and the equipment has been in daily use for months without any issues. Prime Rehab delivers consistency."
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries supply rehabilitation equipment across all states in India?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries supplies rehabilitation equipment to clinics, hospitals, and therapy centres across India, not only in Tamil Nadu. We have completed more than 1,000 installations nationwide."
              }
            },
            {
              "@type": "Question",
              "name": "What is the minimum order quantity for rehabilitation equipment from Prime Rehab?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "There is no minimum order quantity. Prime Rehab Industries supplies equipment to facilities of all sizes, from a single table to a full department setup."
              }
            },
            {
              "@type": "Question",
              "name": "Are Prime Rehab equipment products suitable for hospital rehabilitation departments?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Products such as the High Low Bobath Table and Unweighing System are designed specifically for the patient volumes and clinical demands of hospital settings."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab offer installation and after-sales support for rehabilitation equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries provides installation support and after-sales service for all equipment supplied nationwide."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Rehabilitation Equipment Manufacturer in India",
              "item": "https://www.primerehabindustries.in/blog/rehabilitation-equipment-manufacturer-india"
            }
          ]
        }
      ]
    };

    document.title = "Rehabilitation Equipment Manufacturer India | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab is a trusted rehabilitation equipment manufacturer in India, serving 500+ clinics and hospitals with 100+ models for every therapy specialty.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/rehabilitation-equipment-manufacturer-india";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="india-layout">
      <Navbar />

      {/* Hero Section */}
      <section className="india-hero">
        <div className="india-container">
          <div className="india-hero-inner">
            <div className="india-hero-content">
              <span className="india-tag">Rehabilitation Equipment Guide</span>
              <h1>Rehabilitation Equipment Manufacturer in India</h1>
              <p>
                Reliable supply and nationwide support for clinics and hospitals. Trusted by 500+ facilities with 1,000+ installations completed across the country.
              </p>
              <div style={{ display: 'flex', gap: '16px' }}>
                <a href="/contact" className="india-btn">Request a Quote</a>
                <a href="tel:+919994351947" className="india-btn" style={{ backgroundColor: 'transparent', border: '2px solid var(--india-primary)', color: 'var(--india-primary)' }}>+91 99943 51947</a>
              </div>
            </div>
            <div className="india-hero-image-wrap">
              <img src="https://primerehabindustries.in/Image/Product/Pro5.png" alt="High Low Traction Table by Prime Rehab Industries rehabilitation equipment manufacturer in India" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="india-section">
        <div className="india-container">
          <div className="india-grid-3">
            <div className="india-feature-card">
              <h3>Direct Manufacture</h3>
              <p>Every product is fabricated at our Chennai facility, giving us full control over material quality and fabrication standards.</p>
            </div>
            <div className="india-feature-card">
              <h3>Nationwide Supply</h3>
              <p>We bridge the gap between major cities and smaller towns, delivering high-quality equipment to any location in India.</p>
            </div>
            <div className="india-feature-card">
              <h3>Direct Support</h3>
              <p>Skip the intermediaries. Get expert technical support and after-sales service directly from the people who made the equipment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Block 1 */}
      <section className="india-section" style={{ backgroundColor: '#f8fafc' }}>
        <div className="india-container">
          <div className="india-content-split">
            <div className="india-text-block">
              <h2>Manufacturing for Indian Clinical Conditions</h2>
              <p>
                Imported equipment is often designed for controlled clinical environments. Indian clinical settings vary significantly.
              </p>
              <p>
                Prime Rehab equipment is built to perform across these conditions: frames are heavy-gauge steel, electrical components are rated for local power specifications, and upholstery is selected for longevity in diverse climates.
              </p>
            </div>
            <div className="india-image-block">
              <img src="https://primerehabindustries.in/Image/Product/Pro2.png" alt="Prime Rehab Manufacturing Excellence" />
            </div>
          </div>
        </div>
      </section>

      {/* Product Range */}
      <section className="india-section">
        <div className="india-container">
          <div className="india-text-block" style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2>Core Rehabilitation Specialties</h2>
          </div>
          <div className="india-range-grid">
            <div className="india-range-item">
              <h4>01. Spinal Rehabilitation</h4>
              <p>High Low Traction Tables and SPINETHERA DTS Tables designed for intermittent traction and spinal decompression therapy.</p>
            </div>
            <div className="india-range-item">
              <h4>02. Neurological Recovery</h4>
              <p>Wide-surface Bobath Tables and motorised Unweighing Systems for gait training and neurodevelopmental therapy.</p>
            </div>
            <div className="india-range-item">
              <h4>03. Orthopaedic & Post-Surgical</h4>
              <p>Tilting tables and motorised positioning solutions for passive mobilisation and progressive weight-bearing stages.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 1 */}
      <section className="india-testimonial">
        <div className="india-container">
          <div className="india-test-box">
            <div className="india-test-icon">“</div>
            <div className="india-test-content">
              <blockquote>
                "We were struggling to find a manufacturer who could supply and support equipment in our region. Prime Rehab delivered on time and their after-sales follow-up has been reliable."
              </blockquote>
              <cite>— Preethi Shanmugam, Senior Physiotherapist, Trichy</cite>
            </div>
          </div>
        </div>
      </section>

      {/* Choice Section */}
      <section className="india-section">
        <div className="india-container">
          <div className="india-text-block" style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2>What to Look for in an Indian Manufacturer</h2>
          </div>
          <div className="india-grid-3">
            <div className="india-feature-card" style={{ borderTopColor: '#f59e0b' }}>
              <h3>Transparency</h3>
              <p>Always confirm if the supplier is a manufacturer or a reseller. Manufacturers offer better control over quality and specifications.</p>
            </div>
            <div className="india-feature-card" style={{ borderTopColor: '#f59e0b' }}>
              <h3>Service Range</h3>
              <p>Confirm how service requests are handled outside major metros. Reliable support regardless of location is critical.</p>
            </div>
            <div className="india-feature-card" style={{ borderTopColor: '#f59e0b' }}>
              <h3>Scalability</h3>
              <p>Choose a manufacturer that covers the full rehab spectrum so you don't have to switch suppliers as you grow.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 2 */}
      <section className="india-testimonial">
        <div className="india-container">
          <div className="india-test-box">
            <div className="india-test-icon">“</div>
            <div className="india-test-content">
              <blockquote>
                "Prime Rehab equipped our hospital department in Salem with tilt tables and Bobath tables. For a hospital department, consistency matters, and Prime Rehab delivers that."
              </blockquote>
              <cite>— Dr. Ramesh Babu, Head of Rehabilitation, Salem</cite>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="india-section india-faq-section">
        <div className="india-container">
          <div className="india-text-block" style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="india-faq-grid">
            <div className="india-faq-card">
              <h5>Does Prime Rehab supply equipment across all states?</h5>
              <p>Yes. We have completed over 1,000 installations nationwide, serving clinics and hospitals in every corner of India from our Chennai headquarters.</p>
            </div>
            <div className="india-faq-card">
              <h5>What is the minimum order quantity?</h5>
              <p>There is no minimum order. We supply everything from a single table for a private clinic to full setups for multi-specialty hospitals.</p>
            </div>
            <div className="india-faq-card">
              <h5>Is your equipment suitable for hospital departments?</h5>
              <p>Absolutely. Our motorised models are designed for high-frequency clinical use and have proven their durability in busy hospital environments.</p>
            </div>
            <div className="india-faq-card">
              <h5>Do you offer installation and after-sales support?</h5>
              <p>Yes. We provide installation support and direct after-sales service for all our equipment across the country.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="india-cta-wrap">
        <div className="india-container">
          <h2>Equip Your Clinic with India's Trusted Manufacturer</h2>
          <p>Get factory pricing, consistent build quality, and nationwide supply for your rehabilitation department.</p>
          <a href="/contact" className="india-btn">Get a Direct Quote</a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RehabManufacturerIndia;
